//@ts-nocheck
//@ts-nocheck
import { observer } from "mobx-react-lite";
import React, { useContext } from "react";
import { isDefined } from "../../utils/functions";
import { useFormSubmission } from "../../utils/hooks";
import LessonScheduleForm from "../parent-flow/forms/LessonScheduleForm";
import { RequestDataContext } from "./RequestDataProvider";

const emptySchedule = {
  lessonDays: [],
  lessonHours: "",
  lessonTime: "",
  lessonDuration: "",
  lessonUrgency: "",
};

export function useSchedulePageProps(
  onSubmit = () => {},
  toNextPage = () => {},
  sessionID
) {
  let {
    requestData: { lessonDetails, splitRequests },
    isOneTeacherOption,
    onUpdateSchedule,
  }: any = useContext(RequestDataContext);

  let initialSchedule =
    isDefined(lessonDetails) && isDefined(lessonDetails.lessonSchedule)
      ? lessonDetails.lessonSchedule
      : emptySchedule;

  let numberOfTeachers = splitRequests.length;

  const onSubmitForm = (data) => {
    let result = onUpdateSchedule(data, data.lessonDays);
    return result;
  };

  let [loading, handleSubmit] = useFormSubmission(
    onSubmit,
    toNextPage,
    onSubmitForm,
    sessionID
  );
  return {
    isOneTeacherOption,
    loading,
    handleSubmit,
    splitRequests,
    initialSchedule,
    numberOfTeachers,
  };
}

const LessonSchedulePage: React.FC<{ [key: string]: any }> = observer(
  ({
    loading,
    onSubmit,
    onBackClick,
    numberOfTeachers,
    viewModel,
    teacherOption,
    submitText,
  }) => {
    return (
      <LessonScheduleForm
        viewModel={viewModel}
        teacherOption={teacherOption}
        minimumDays={numberOfTeachers}
        onSubmit={onSubmit}
        submitText={submitText}
        onBackClick={onBackClick}
        loading={loading}
      />
    );
  }
);

export default LessonSchedulePage;
